export default "__VITE_ASSET__a8e78b11__"